import { Send } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import { ConfirmationDialog } from 'shared/components';
import { useAcceptProducts } from 'shared/mutations';
import { UserInfo } from 'shared/types';
import { useProductState } from './state';
interface GridToolbarAcceptProductsProps {
  user: UserInfo;
}
export function GridToolbarAcceptProducts({ user }: GridToolbarAcceptProductsProps) {
  const state = useProductState();
  const selectedIds = state.selectedIds.get();
  const showSelectedProducts = Boolean(selectedIds.length);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const apiRef = useGridApiContext();
  const buttonText = `accept ${selectedIds.length} products`;

  const acceptMutation = useAcceptProducts();

  return (
    <>
      <Box>
        {showSelectedProducts && (
          <Button
            onClick={() => {
              setConfirmOpen(true);
            }}
            startIcon={<Send />}
            color='secondary'
          >
            {buttonText}
          </Button>
        )}
      </Box>
      <ConfirmationDialog
        open={confirmOpen}
        ok={async () => {
          await acceptMutation.mutateAsync({
            ids: selectedIds.map(id => ({ id })),
            parameters: { userEmail: user.email, userId: user.id },
          });
          apiRef.current.setSelectionModel([]);
          setConfirmOpen(false);
        }}
        cancel={() => {
          setConfirmOpen(false);
        }}
      >
        Change status of {selectedIds.length} Product(s) to accepted ?
      </ConfirmationDialog>
    </>
  );
}
